<template>
  <div id="dialogFour">
    <div class="h-dialogContainer">
      <form id='taskDialog1'>
        <div class="row h-row-inputBox">
          <div class="col-sm-6 h-col-inputBox">
            <div class="h-inputLit"><span class="h-red-code">* </span>{{$t('Pm.taskName')}}:</div>
            <div class="e-input-group e-control-wrapper">
              <input class="e-control e-textbox e-lib e-input" :readonly="status.readForTaskName" @blur="blurOftaskName" name="taskName" type="text" v-model="paramsOfDialog1.sysMeterTaskName">
            </div>
          </div>
        </div>
        <div class="row h-row-inputBox">
          <div class="col-sm-6 h-col-inputBox">
            <div class="h-inputLit">{{$t('Pm.taskDescription')}}:</div>
            <div class="e-input-group e-control-wrapper">
              <input class="e-control e-textbox e-lib e-input" type="text" name="taskDepict" v-model="paramsOfDialog1.sysMeterTaskDepict">
            </div>
          </div>
        </div>
        <div class="row h-row-inputBox">
          <div class="col-sm-6 h-col-inputBox">
            <div class="h-inputLit"><span class="h-red-code">* </span>{{$t('Pm.resourceType')}}:</div>
            <div class="e-input-group e-control-wrapper">
              <ejs-dropdownlist id='neType' :enabled="status.neTypeEnabled" :dataSource='dataSourceOfNeType' :fields='fieldsOfNeType' v-model="paramsOfDialog1.neType"></ejs-dropdownlist>
            </div>
          </div>
        </div>
        <div class="row h-row-inputBox">
          <div class="col-sm-6 h-col-inputBox">
            <div class="h-inputLit"><span class="h-red-code">* </span>{{$t('Pm.measureCycle')}}:</div>
            <div class="e-input-group e-control-wrapper">
              <ejs-dropdownlist id='timeCycle' :enabled="status.timeCycleEnabled"  :dataSource='dataSourceOfCycle' :fields='fieldsOfCycle' v-model="paramsOfDialog1.meterTimePeriod"></ejs-dropdownlist>
            </div>
          </div>
        </div>
        <div class="row h-row-inputBox">
          <div class="col-sm-6 h-col-inputBox">
            <div class="h-inputLit"><span class="h-red-code">* </span>{{$t('Pm.timeMode')}}:</div>
            <div class="e-input-group e-control-wrapper">
              <ejs-dropdownlist id='timeMode' :enabled="status.timeModeEnabled"  :dataSource='dataSourceOfTimeMode' :fields='fieldsOfTimeMode' :change="onTimeModeChange" v-model="paramsOfDialog1.effectiveTimeMode"></ejs-dropdownlist>
            </div>
          </div>
        </div>
        <div class="row h-row-inputBox">
          <div class="col-sm-6 h-col-inputBox">
            <div class="h-inputLit"><span class="h-red-code">* </span>{{$t('Pm.start_time')}}：</div>
            <ejs-datetimepicker :change='validateOfDialog1' :enabled='status.begTimeEnabled' :locale='locale' :format='dateFormat' v-model='paramsOfDialog1.meterBegTime'  name="startTime"></ejs-datetimepicker>
          </div>
        </div>
        <div class="row h-row-inputBox">
          <div class="col-sm-6 h-col-inputBox">
            <div class="h-inputLit"><span class="h-red-code">* </span>{{$t('Pm.end_time')}}：</div>
            <ejs-datetimepicker :change='validateOfDialog1' :enabled='status.endTimeEnabled' :locale='locale' :format='dateFormat' :max='maxDateOfEndTime' v-model='paramsOfDialog1.meterEndTime' name="endTime"></ejs-datetimepicker>
          </div>
        </div>
        <div class="h-clear-rowMg"></div>
      </form>
    </div>
  </div>
</template>

<script>
import { FormValidator } from '@syncfusion/ej2-vue-inputs';

export default {
  name: 'AddOrModifyTaskDialog1',
  data() {
    return {
      status: {
        begTimeEnabled: false,
        endTimeEnabled: false,
        neTypeEnabled: true,
        timeCycleEnabled: true,
        timeModeEnabled: true,
        readForTaskName: false,
      },
      maxDateOfEndTime: new Date(2100, 11, 31),
      dateFormat: 'yyyy-MM-dd HH:mm:ss',
      paramsOfDialog1: {
        neType: '101',
        sysMeterTaskName: 'TASK_',
        sysMeterTaskDepict: '',
        meterTimePeriod: 2,
        effectiveTimeMode: '1',
        meterBegTime: new Date(),
        meterEndTime: new Date('2099-12-31 23:59:59'),
      },
      locale: localStorage.getItem('locale'),
      dataSourceOfNeType: [
      ],
      fieldsOfNeType: {
        text: 'neTypeCode',
        value: 'neTypeId'
      },

      dataSourceOfCycle: [
        { id: 2, time: this.$t('Pm.fifteenMinutes') }
      ],
      fieldsOfCycle: { value: 'id', text: 'time' },

      dataSourceOfTimeMode: [
        { id: '0', name: this.$t('Pm.periodTime') },
        { id: '1', name: this.$t('Pm.longTime') }
      ],
      fieldsOfTimeMode: {
        text: 'name',
        value: 'id'
      },
      formObjOfDialog1: '',
      optionsOfDialog1Validation: {
        customPlacement(inputElement, errorElement) {
          errorElement.style.position = 'fixed';
          inputElement.parentElement.parentElement.appendChild(errorElement);
        },
        rules: {
          taskName: {
            required: [true, this.$t('Pm.taskNameNull')],
            regex: [/^[^\'\\\"\<\>]+$/, this.$t('Pm.onlyNumAndLetter')],
            maxLength: [60, this.$t('Pm.taskNameOver60')]
          },
          taskDepict: {
            maxLength: [256, this.$t('Pm.taskDespOver256')]
          },
          startTime: {
            required: [true, this.$t('Pm.begTimeNull')],
            regex: [/^[1-9]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])\s+(20|21|22|23|[0-1]\d):[0-5]\d:[0-5]\d$/, this.$t('Pm.begTimeFormatError')]
          },
          endTime: {
            required: [true, this.$t('Pm.endTimeNull')],
            regex: [/^[1-9]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])\s+(20|21|22|23|[0-1]\d):[0-5]\d:[0-5]\d$/, this.$t('Pm.endTimeFormatError')]
          }
        }
      }
    };
  },
  props: [
    'addOrModifyTaskFlag'
  ],
  methods: {
    init() {
      this.$axios.post('/lte/pm/measuretaskmanagement/getNeType.html').then((response) => {
        this.dataSourceOfNeType = response.data.resultVal;
        this.paramsOfDialog1.neType = response.data.resultVal[0].neTypeId;
      });
    },
    onTimeModeChange(msg) {
      if (msg.value == '1') {
        const currentDate = new Date();
        this.paramsOfDialog1.meterBegTime = currentDate;
        this.paramsOfDialog1.meterEndTime = new Date('2099-12-31 23:59:59');
        this.status.endTimeEnabled = false;
        this.status.begTimeEnabled = false;
      } else {
        this.paramsOfDialog1.meterBegTime = '';
        this.paramsOfDialog1.meterEndTime = '';
        this.status.endTimeEnabled = true;
        this.status.begTimeEnabled = true;
      }
    },
    validateOfDialog1() {
      const formStatus = this.formObjOfDialog1.validate();
      if (!formStatus) {
        return false;
      }
      return true;
    },
    bindValidateOfDialog1() {
      this.formObjOfDialog1 = new FormValidator('#taskDialog1', this.optionsOfDialog1Validation);
    },
    blurOftaskName(event) {
      const msg = event.target.value;
      if (msg != null && msg != '' && msg.indexOf('TASK_') == -1) {
        this.paramsOfDialog1.sysMeterTaskName = `TASK_${msg}`;
      }
    }
  },
  mounted() {
    this.bindValidateOfDialog1();
    this.init();
  },
  watch: {
    addOrModifyTaskFlag(msg) {
      if (msg == '1') {
        this.status.begTimeEnabled = true;
        this.status.endTimeEnabled = true;
        this.status.neTypeEnabled = true;
        this.status.timeCycleEnabled = true;
        this.status.timeModeEnabled = true;
        this.status.readForTaskName = false;
        this.status.readForTaskDesc = false;
      } else {
        this.status.begTimeEnabled = false;
        this.status.endTimeEnabled = false;
        this.status.neTypeEnabled = false;
        this.status.timeCycleEnabled = false;
        this.status.timeModeEnabled = false;
        this.status.readForTaskName = true;
        this.status.readForTaskDesc = true;
      }
    }
  }
};
</script>

<style scoped>

</style>
